import React from 'react';
import { Row, Col, Space, Input, Select, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import DateRangeFilter from '../../components/DateRangeFilter';

const { Option } = Select;

const PaymentFilters = ({
  filters,
  setFilters,
  dateFilter,
  onDateFilterChange,
  vans,
  channels,
  onFetch,
  onCreatePayment,
}) => (
  <>
    <Row gutter={[8, 8]} align="middle" style={{ marginBottom: 24, flexWrap: 'wrap' }}>
      <Col flex="none">
        <Space direction="vertical" size={2} style={{ width: 320, marginRight: 128 }}>
          <span style={{ fontWeight: 500 }}>Date Range:</span>
          <DateRangeFilter value={dateFilter} onChange={onDateFilterChange} placeholder="Date Range" />
        </Space>
      </Col>
    </Row>

    <Row gutter={[8, 8]} align="middle" style={{ marginBottom: 16, flexWrap: 'wrap', display: 'flex' }}>
      <Col flex="220px" style={{ marginRight: 16 }}>
        <Input.Search
          placeholder="Search by reference, customer, etc."
          value={filters.search || ''}
          onChange={e => setFilters(f => ({ ...f, search: e.target.value }))}
          onSearch={onFetch}
          allowClear
          style={{ width: '100%' }}
        />
      </Col>
      <Col flex="140px">
        <Select
          style={{ width: '100%' }}
          placeholder="Category"
          allowClear
          value={filters.category || undefined}
          onChange={value => setFilters(f => ({ ...f, category: value }))}
        >
          <Option value="fuel">Fuel</Option>
          <Option value="maintenance">Maintenance</Option>
          <Option value="insurance">Insurance</Option>
          <Option value="insurance claim">Insurance Claim</Option>
          <Option value="salary">Salary</Option>
          <Option value="van rental">Van Rental</Option>
          <Option value="van deposits">Van Deposits</Option>
          <Option value="tracking charges">Tracking Charges</Option>
          <Option value="office">Office</Option>
          <Option value="job">Job</Option>
          <Option value="charges">Charges</Option>
          <Option value="porter">Porter</Option>
          <Option value="accounting services">Accounting Services</Option>
          <Option value="paye">PAYE</Option>
          <Option value="excess mileage">Excess Mileage</Option>
          <Option value="vat liability">VAT Liability</Option>
          <Option value="other">Other</Option>
        </Select>
      </Col>
      <Col flex="140px" style={{ marginLeft: 32 }}>
        <Select
          style={{ width: '100%' }}
          placeholder="Van"
          allowClear
          value={filters.van || undefined}
          onChange={value => setFilters(f => ({ ...f, van: value }))}
          showSearch
          optionFilterProp="children"
        >
          <Option value="N/A">N/A</Option>
          {vans.map(van => (
            <Option key={van._id} value={van._id}>{van.registration}</Option>
          ))}
        </Select>
      </Col>
      <Col flex="140px" style={{ marginLeft: 32 }}>
        <Select
          style={{ width: '100%' }}
          placeholder="PL Position"
          allowClear
          value={filters.plPosition || undefined}
          onChange={value => setFilters(f => ({ ...f, plPosition: value || '' }))}
        >
          <Option value="">All</Option>
          <Option value="income">Income</Option>
          <Option value="expense">Expense</Option>
        </Select>
      </Col>
      <Col flex="140px" style={{ marginLeft: 32 }}>
        <Select
          style={{ width: '100%' }}
          mode="multiple"
          value={filters.status}
          onChange={value => setFilters(f => ({ ...f, status: value }))}
          allowClear
          placeholder="Status"
          maxTagCount={1}
        >
          <Option value="paid">Paid</Option>
          <Option value="pending">Pending</Option>
          <Option value="overdue">Overdue</Option>
          <Option value="cancelled">Cancelled</Option>
        </Select>
      </Col>
      <Col flex="180px" style={{ marginLeft: 32 }}>
        <Select
          style={{ width: '100%' }}
          placeholder="Channel"
          allowClear
          value={filters.channel || undefined}
          onChange={value => setFilters(f => ({ ...f, channel: value }))}
          showSearch
          optionFilterProp="children"
        >
          {channels.map(ch => (
            <Option key={ch._id || ch.name} value={ch.name}>{ch.name}</Option>
          ))}
        </Select>
      </Col>
      <Col flex="auto" style={{ textAlign: 'right', minWidth: 120 }}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={onCreatePayment}
          style={{ minWidth: 100 }}
        >
          Create
        </Button>
      </Col>
    </Row>
  </>
);

export default PaymentFilters;
